import {
  FormControlLabel as FormControlLabelMui,
  RadioGroup as RadioGroupMui,
  styled,
  Typography,
} from '@mui/material';

import devices from '../../../../styles/devices';
import { colorPrimary } from '../../../../styles/mui/colors';

export const Section = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--spacing-big)',
  padding: 'var(--spacing-small) var(--spacing-big)',
}));

export const FormDescription = styled(Typography)(() => ({
  color: 'var(--color-text-light)',
  marginBottom: 'var(--spacing-big)',
}));

export const RadioGroup = styled(RadioGroupMui)(() => ({
  display: 'grid',
  gap: 'var(--spacing-tiny)',
  gridAutoFlow: 'row',

  [`@media ${devices.tabletS}`]: {
    gridAutoFlow: 'column',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
  },
}));

/**
 * @todo Refactor these styles.
 */
export const FormControlLabel = styled(FormControlLabelMui)(() => ({
  '& > .MuiTypography-root': {
    '& > div > div': {
      backgroundColor: 'var(--color-background)',
      borderRadius: 'var(--border-radius-tiny)',
    },
    margin: '0 var(--spacing-tiny)',
    width: '100%',
  },
  '&:has(.Mui-checked)': {
    '&:hover': {
      backgroundColor: colorPrimary[100],
    },
    backgroundColor: colorPrimary[50],
  },
  '&:hover': {
    backgroundColor: '#eeeeee',
  },
  borderRadius: 'var(--border-radius-tiny)',
  margin: '0',
}));
